import React, { useState, useEffect } from 'react';
import ItemListSpaces from '../common/ItemListSpaces';
import CommonTable from '../common/CommonTable';
import TableRowsIcon from '@mui/icons-material/TableRows';
import AppsIcon from '@mui/icons-material/Apps';
import { fetchData } from '../common/Api';
import { commonColumns } from '../common/TableColumns';
import { useHistory } from 'react-router-dom';
import { useAuth } from '../common/AuthProvider';


const Spaces = () => {

    const history = useHistory();
    const [spaces, setSpaces] = useState([]);    
    const [listViewSelected, setListViewSelected] = useState(true);
    const [gridViewSelected, setGridViewSelected] = useState(false);
    const [error, setError] = useState(null);
    
    const getSpaces = async () => {
        try {
            await fetchData(`/api/v1/spaces`)
            .then(response => setSpaces(response.data));
        } catch (error) {
            setError(error);
        }
    };

    useEffect(() => { 
        getSpaces(); 
    }, []);

    useEffect(()=> {
        if (error) {
            if (error.status === 401){
                alert(`Error loading spaces :: ${error.message}`);
                history.push('/login');
            } 
        }
    }, [error]);

    const handleViewSwitch = (listView, gridView) => {
        setListViewSelected(listView);
        setGridViewSelected(gridView);
    }

    return (
    <div className='page-container'>
        <div className="switch-view-group">
        <h2>Spaces</h2>
            <div>
            <TableRowsIcon className={`switch-view ${listViewSelected ? 'selected' : null}`} 
                onClick={() => handleViewSwitch(true, false)}/>
            <AppsIcon className={`switch-view ${gridViewSelected ? 'selected' : null}`} 
                onClick={() => handleViewSwitch(false, true)}/>  
            </div>
        </div>
        { listViewSelected ? 
            <ItemListSpaces 
                data={spaces} 
                cols={commonColumns}
                baseUrl={`/api/v1/spaces`} 
                setData={getSpaces}
                fields={['name', 'description']}
                /> : 
            <CommonTable data={spaces} cols={commonColumns} /> 
        }
    </div>
    );
};

export default Spaces;

